































import { windowHelper } from '@tencent/ppd-base-libs';
import { Tag } from '@/components/v3/tag';
import TextCom from '@/components/v3/text/index.vue';
import { HotNews } from '@/types/home-newest';
import { biClick } from '@tencent/fit-bi-sdk';
import { defineComponent, PropType, computed } from '@vue/composition-api';

export default defineComponent({
  name: 'HotNewsItem',
  components: {
    TextCom,
    Tag,
  },
  props: {
    item: {
      type: Object as PropType<HotNews>,
      required: true,
    },
  },
  setup(props) {
    const biExt = computed(() => props.item.reportInfo);
    return {
      biExt,
      goDetail() {
        windowHelper.redirect(props.item.url, 300);
        biClick('hot-news.item_click|热门资讯点击', biExt.value);
      },
    };
  },
});
